import { useMutation } from '@tanstack/react-query';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';
import { UpdateAuthorFavorite } from '@src/api/users.ts';

export const useAddAuthorToFavoriteMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateAuthorFavorite) =>
      await API.users.addAuthorToFavorites(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['authors'] });
    },
  });
};
